import { WidgetStreamStreamingConfig } from 'widgets/streaming/WidgetStreamConfig';
import {
    PortfolioReturnsStreamRequest,
    PortfolioReturnsStreamRequest as CommsStreamRequest,
} from 'communication/types/portfolioReturns/PortfolioReturnsStreamRequest';
import { buildPortfolioReturnsStreamHandlers } from 'widgets/portfolioReturns/store/stream/handler';
import PortfolioReturnsDataMessage from 'communication/types/portfolioReturns/PortfolioReturnsDataMessage';
import { createPortfolioReturnsStreamRequestPayload } from 'widgets/portfolioReturns/store/stream/PortfolioReturnsStreamRequest';
import { buildPortfolioReturnsStreamSlice } from 'widgets/portfolioReturns/store/stream/streamSlice';
import { ActionsDispatcher } from 'store/ActionsDispatcher';
import { createUpdateWidgetComponentStateAction } from 'widgets/store/component/actions';
import { WidgetType } from 'widgets/WidgetType';
import { PortfolioReturnsComponentState } from 'widgets/portfolioReturns/store/component/PortfolioReturnsComponentState';
import { PortfolioItem } from 'portfolio/PortfolioItem';
import State from 'store/State';
import { computeAverageExecPriceBenchmarkReferenceValues } from '../../averageExecPriceBenchmark';

const { actions, selectors } = buildPortfolioReturnsStreamSlice();

export const portfolioReturnsStreamConfig: WidgetStreamStreamingConfig<
    CommsStreamRequest,
    PortfolioReturnsDataMessage
> = {
    configType: 'FilteredPortfolioDependentWidgetStreamConfig',
    streamType: 'StreamingStream',
    startChannelDestination: 'startPortfolioReturnsStream',
    selectWidgetStreamKey: selectors.selectStreamKey,
    clearWidgetStreamData: actions.createClearStreamDataAction,
    createPayload: createPortfolioReturnsStreamRequestPayload,
    buildHandlers: buildPortfolioReturnsStreamHandlers,
    subscriptions: {
        appSettings: true,
        widgetConfig: true,
        widgetComponentState: true,
    },
    throttleRequestsMs: 60000,
    onStartStreaming,
};

function onStartStreaming(
    state: State,
    dispatcher: ActionsDispatcher,
    payload: unknown,
    widgetKey: string,
    filteredPortfolio: PortfolioItem[]
) {
    const request = payload as PortfolioReturnsStreamRequest;
    const requestSymbology = request.symbology?.split('`')[0];

    const avgExecRefValues = computeAverageExecPriceBenchmarkReferenceValues(
        filteredPortfolio,
        state,
        widgetKey
    );

    const action =
        createUpdateWidgetComponentStateAction<PortfolioReturnsComponentState>(
            WidgetType.PORTFOLIO_RETURNS
        )(widgetKey, { avgExecRefValues, requestSymbology });
    dispatcher.dispatch(action);
}
